import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumbs, BreadcrumbsProps } from '@otp/ui';

import { PageTitle } from 'src/components/common/page-title';
import { usePageContext } from 'src/context/page.context';
import { useDeviceContext } from 'src/context/device.context';

export interface PageHeaderProps {
  breadcrumbs: BreadcrumbsProps;
  title: string;
}

export const PageHeader = ({ breadcrumbs, title }: PageHeaderProps) => {
  const { isMobile } = useDeviceContext();
  const { setHeader, setBreadcrumbs } = usePageContext();
  setHeader(title);
  setBreadcrumbs(breadcrumbs);

  if (isMobile) {
    return null;
  }

  return (
    <div className="px-11 mt-6">
      <Breadcrumbs {...breadcrumbs} Link={Link} />
      <PageTitle title={title} />
    </div>
  );
};
